import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';
import configureStore from './store';
import history from 'router/history';
import { authRef } from 'services/firebaseRef';
import { loginWithAuthData } from 'actions/authActions';

require('autotrack/lib/plugins/url-change-tracker');

const target = document.getElementById('root');
const store = configureStore(window.__INITIAL_STATE__);

let unsubscribe;

function loginAndRenderPage(authData) {
  unsubscribe();
  let promise = Promise.resolve();
  if (authData) {
    promise = promise
      .then(() => store.dispatch(loginWithAuthData({ authData })))
      .catch(err => {
        console.error('Error authenticating with existing user. Forcing signing out.', err);
        authRef.signOut();
      });
  }
  promise.then(() => ReactDOM.render(<Root routerHistory={history} store={store}/>, target));
}
unsubscribe = authRef.onAuthStateChanged(loginAndRenderPage, () => loginAndRenderPage());



// WEBPACK FOOTER //
// ./src/entryPoint.js